import { Component } from '@angular/core';
import {Router} from '@angular/router'
@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  title = 'project';
  constructor(private router:Router){}
  account:any;
  isLogin(){
    if(JSON.parse(localStorage.getItem('log'))){
      this.account=JSON.parse(localStorage.getItem('loginUser'));
      return true;
    }
    return false;

  }
  logout(){
    localStorage.removeItem('log');
    localStorage.removeItem('loginUser');
    localStorage.removeItem('pre');
    localStorage.removeItem('admin');
    console.log("dssssssssssssssssssssssss");
    this.router.navigate(['home']);
  }
}
